/**
 * Chemins des ecrans sans coque. Ecrits une fois ici : `App.tsx` les monte, les
 * pages s'y renvoient, et un chemin recopie diverge sans qu'aucun test ne tombe.
 */
export const LOGIN_PATH = '/login';
export const FORGOT_PASSWORD_PATH = '/forgot-password';
export const RESET_PASSWORD_PATH = '/reset-password';
